import dayjs from 'dayjs'

import { DEFAULT_TIMEZONE } from '@/components/entities/requests/model/constants'

type Props = {
  date: Date
  label: string
}

const splitDateTime = (value: string | Date) => {
  const date = dayjs(value).tz(DEFAULT_TIMEZONE)
  const isCurrentYear = date.year() === dayjs().tz(DEFAULT_TIMEZONE).year()

  return {
    date: date.format(isCurrentYear ? 'D MMMM' : 'D MMMM YYYY'),
    time: date.format('HH:mm')
  }
}

export const SummaryBlock = ({ date, label }: Props) => (
  <div className="flex h-[164px] w-[164px] flex-col items-center justify-center gap-4 rounded-16 bg-grey-10 xs:w-full">
    {label && <p className="text-grey-60 text-16">{label}</p>}
    <strong className="text-44">{splitDateTime(date).time}</strong>
    <p className="text-16">{splitDateTime(date).date}</p>
  </div>
)
